import { Button, Intent } from "@blueprintjs/core";
import { saveAs } from "file-saver";
import { FGSelectInput, FieldGroup, FieldSet, showError } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";

import { CompetitionRequestApi, FileDownload, PersonApi } from "../../api";
import { SmallFormGenerator } from "../../components";
import { useApiService, useTl } from "../../hooks";
import { useReferential } from "../../hooks/useReferential";
import { ETLCodes } from "../../locales/ETLCodes";
import { b64toBlob } from "../../utils";

export interface IMemberReportProps {}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 0.75rem;
`;

export const MemberReport: React.FunctionComponent<IMemberReportProps> = (props) => {
  const { t } = useTl();
  const api = useApiService(PersonApi);
  const [saving, setsaving] = React.useState(false);
  const getDoc = React.useCallback(async () => {
    try {
      setsaving(true);
      var file = await api.getMemberReport();
      if (file?.fileBytes) {
        var blob = b64toBlob(new FileDownload({ base64Content: file.fileBytes, fileName: file.fileName }));
        saveAs(blob, file.fileName);
      }
      setsaving(false);
    } catch {
      showError(t(ETLCodes.Error));
      setsaving(false);
    }
  }, [api, t]);

  return (
    <FieldSet title={t(ETLCodes.MembersReport)}>
      <SmallFormGenerator
        initialValues={{}}
        onSubmit={getDoc}
        editMode={true}
        showDeleteButton={false}
        hideButtons={true}
      >
        <Container>
          <Button
            type={"submit"}
            text={t(ETLCodes.GenerateReport)}
            loading={saving}
            intent={Intent.PRIMARY}
            icon={<i className="far fa-file-excel" />}
          />
        </Container>
      </SmallFormGenerator>
    </FieldSet>
  );
};
